import * as React from 'react';
export const sandboxSvg = React.forwardRef(function sandboxSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.098 1.688a2 2 0 0 1 .846-.188h.112a2 2 0 0 1 .846.188l5.944 2.773A2 2 0 0 1 16 6.274v3.49a2 2 0 0 1-1.106 1.789l-5.26 2.63a3 3 0 0 1-1.342.317h-.584a3 3 0 0 1-1.341-.317l-5.261-2.63A2 2 0 0 1 0 9.763v-3.49a2 2 0 0 1 1.154-1.812l5.944-2.773Zm7.402 5.4v2.676a.5.5 0 0 1-.276.447l-5.261 2.63c-.07.035-.14.064-.213.087V9.964l5.75-2.875Zm-.563-1.395-2.482 1.24L8.6 5.617V3.202l5.338 2.49ZM7.4 3.202l-5.337 2.49 2.482 1.242L7.4 5.616V3.202Zm.6 5.46 2.08-1.04L8 6.66l-2.08.96L8 8.661ZM1.5 7.089l5.75 2.875v2.964a1.493 1.493 0 0 1-.213-.086l-5.26-2.63a.5.5 0 0 1-.277-.448V7.089Z',
    }),
  );
});
sandboxSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sandbox = {
  category: 'icon',
  colorable: true,
  name: 'sandbox',
  svg: sandboxSvg,
};
